import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPaymentsIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 50,
	height: 50,
	viewBox: "0 0 50 50",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M25 50C38.8071 50 50 38.8071 50 25C50 11.1929 38.8071 0 25 0C11.1929 0 0 11.1929 0 25C0 38.8071 11.1929 50 25 50Z",
		fill: "black"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M32 27V19C32 17.9 31.1 17 30 17H16C14.9 17 14 17.9 14 19V27C14 28.1 14.9 29 16 29H30C31.1 29 32 28.1 32 27ZM30 27H16V19H30V27ZM23 20C21.34 20 20 21.34 20 23C20 24.66 21.34 26 23 26C24.66 26 26 24.66 26 23C26 21.34 24.66 20 23 20ZM36 20V31C36 32.1 35.1 33 34 33H17C17 32 17 32.1 17 31H34V20C35.1 20 35 20 36 20Z",
		fill: "white"
	})]
});
export default SvgPaymentsIcon;
